export default __webpack_public_path__ + "befab796df8124ae7a07b8d7262ca73b.png";